import Affiliate from "../views/frontend/Affiliate/Affiliate";
import AffiliateSmall from "../views/frontend/Affiliate/AffiliateSmall";

export default {
  Affiliate: {
    component: Affiliate,
    path: "/affiliate/:affiliateID?"
  },
  AffiliateSmall: {
    component: Affiliate,
    path: "/affiliate-small/:affiliateID?"
  },
};



// WEBPACK FOOTER //
// ./src/app/routes/affiliateRoutes.js